// import { initReactI18next} from "react-i18next";
import i18next from "i18next";

export function errorMessageFormatter(err: any): string {
  const t = i18next.t


  const status: any = {
    '-1': t("APP_ADMIN_CORE_ERRORS_SERVER_NOT_FOUND"),
    400: t("APP_ADMIN_CORE_ERRORS_INVALID_DATA"),
    401: t("APP_ADMIN_CORE_ERRORS_NO_ACCESS_PERMISSION"),
    403: t("APP_ADMIN_CORE_ERRORS_NO_ACCESS_PERMISSION"),
    404: t("APP_ADMIN_CORE_ERRORS_NOT_FOUND"),
    422: t("APP_ADMIN_CORE_ERRORS_INVALID_DATA"),
  };
  switch ((err || {}).message) {
    case 'no-internet':
    case 'NETWORK_ERROR':
      return t("APP_ADMIN_CORE_ERRORS_NO_INTERNET_CONNECTION");
    case 'zipcode-not-found':
      return t("APP_ADMIN_CORE_ERRORS_ZIP_NOT_FOUND");
    case 'missing conf':
      return t('APP_ZOHO_CENTER_BOOK_MISSING_CONFIGURATION')
    case 'location duplicated':
      return t("APP_ZOHO_CENTER_BOOK_DUPLICATED_BRANCH_MESSAGE");
    case 'Invoice with this bill_number already created':
      return t("APP_ZOHO_CENTER_TIMESHEET_ALREADY_CREATED_INVOICE");
    case 'api-error':
      if (err.status === -1) {
        return  t("APP_ADMIN_CORE_ERRORS_CANNOT_COMMUNICATE_WITH_SERVER");
      }

      if (err.status === 400) {
        switch ((err?.data || {}).message) {
          case 'email-unavailable':
            return t("APP_ADMIN_CORE_ERRORS_EMAIL_ALREADY_IN_USE");
          case 'username-unavailable':
            return t("APP_ADMIN_CORE_ERRORS_USERNAME_ALREADY_IN_USE");
          case 'document-unavailable':
            return t("APP_ADMIN_CORE_ERRORS_DOCUMENT_ALREADY_IN_USE");
          case 'invalid-credentials':
            return t("APP_ADMIN_CORE_ERRORS_INVALID_CREDENTIALS");
        }
      }

      if (err.status === 403) {
        switch ((err?.data || {}).message) {
          case 'user-has-no-person':
            return t("APP_ADMIN_CORE_ERRORS_NO_MANAGEMENT_OVER_ANY_ENTITY");
          case 'user-cant-access-person':
            return t("APP_ADMIN_CORE_ERRORS_NO_ACCESS_TO_PERSON");
          case 'not-permited':
            return t("APP_ADMIN_CORE_ERRORS_OPERATION_NOT_ALLOWED");
        }
      }

      if (err.status === 409) {
        switch ((err?.data || {}).message) {
          case 'roles-required':
            return t("APP_ADMIN_CORE_ERRORS_USER_ROLE_REQUIRED");
          case 'invalid-roles':
            return t("APP_ADMIN_CORE_ERRORS_INVALID_ROLE");
          case 'not-allowed-remove-current-user':
            return t("APP_ADMIN_CORE_ERRORS_CANNOT_REMOVE_SELF");
          case 'bank-file-already-processed':
            return t("APP_ADMIN_CORE_ERRORS_FILE_ALREADY_SENT");
          case 'bank-file-processing':
            return t("APP_ADMIN_CORE_ERRORS_FILE_ALREADY_BEING_PROCESSED");
          case 'not-allowed-remove-sysAdmin':
            return t("APP_ADMIN_CORE_ERRORS_CANNOT_REMOVE_SYS_ADMIN");
          case 'invalid-credentials':
            return t("APP_ADMIN_CORE_ERRORS_INVALID_CREDENTIALS");
          case 'wrong-current-password':
            return t("APP_ADMIN_CORE_ERRORS_WRONG_CURRENT_PASSWORD");
          case 'token-type-not-match':
            return t("APP_ADMIN_CORE_ERRORS_INCOMPATIBLE_TOKEN_TYPE");
          case 'token-expired':
            return t("APP_ADMIN_CORE_ERRORS_EXPIRED_TOKEN");
          case 'token-invalid':
            return t("APP_ADMIN_CORE_ERRORS_INVALID_TOKEN");
          case 'changing-folder-forbidden':
            return t("APP_ADMIN_CORE_ERRORS_FOLDER_CHANGE_NOT_ALLOWED");
        }
      }

      if (err.status === 422) {
        switch ((err?.data || {}).message) {
          case 'email-unavailable':
            return t("APP_ADMIN_CORE_ERRORS_EMAIL_ALREADY_IN_USE");
          default:
            return `Invalid data: ${err.data?.message || 'Invalid data'}`;
        }
      }

      return (err?.data || {}).message || status[err.status] || t("APP_ADMIN_CORE_ERRORS_SOMETHING_WENT_WRONG");
    default:
      return t("APP_ADMIN_CORE_ERRORS_SOMETHING_WENT_WRONG");
  }
}
